module.exports = __webpack_public_path__ + "media/images/covid/icons/thermoS-fe8c572543f055727408f18654505bd2.png";